import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import TenantActions from '@Actions/tenantActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import {
  Table, Select, notification, Popconfirm,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import {
  DeleteOutlined, PlusCircleFilled,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import documentUINamesConstant from '../../../../../../../../apis/documentUINamesConstant';
import PRZSelect from '../../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const ZohoPullTenantMapping = ({
  user, getTenants, getTenantsLoading, tenants, getZohoConnections, zohoConnections, connectTenantToLocationLoading, getZohoConnectionsLoading, setZohoPullTenantMapping, preFillData
}) => {
  const [tenantData, setTenantData] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
    getZohoConnections(user?.tenant_info?.org_id);
  }, []);
  useEffect(() => {
    const copyTenantData = preFillData?.pull_zoho_location_mapping?.filter((item) => item?.zoho_branch_id)?.map((tenant) => ({ ...tenant, zoho_branch_id: tenant?.zoho_branch_id, key: uuidv4() }));
    setTenantData(copyTenantData);
    setZohoPullTenantMapping(copyTenantData);
  }, [preFillData]);

  const isDataValid = (data) => {
    const copyData = data?.filter((item) => !item?.is_deleted);
    for (let i = 0; i < copyData?.length; i++) {
      if (!data[i]?.tenant_id || !data[i]?.zoho_branch_id) {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    if (isDataValid(tenantData) && tenantData?.filter((item) => !item?.is_deleted && item?.tenant_id && item?.zoho_branch_id).length > 0) {
      const payload = tenantData?.filter((t) => t?.tenant_id)?.map((tenant) => (
        {
          tenant_id: tenant.tenant_id,
          zoho_branch_id: tenant?.is_deleted ? null : tenant.zoho_branch_id,
          org_id: user?.tenant_info?.org_id,
        }
      ));
      setZohoPullTenantMapping(payload);
    }
  };

  const updateTableValue = (key, value, label) => {
    const data = tenantData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTenantData(data);
    handleSubmit();
  };

  const addNewRow = () => {
    if (tenantData?.length) {
      setTenantData([...tenantData, { key: uuidv4() }]);
    } else {
      setTenantData([{}]);
    }
  };
  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data)) : []);

  const removeRow = (key) => {
    if (tenantData.length > 1) {
      const copyData = tenantData.filter((item) => item.key !== key);
      const payload = copyData?.filter((t) => t?.tenant_id)?.map((tenant) => ({
        tenant_id: tenant.tenant_id,
        zoho_branch_id: tenant?.zoho_branch_id,
        org_id: user?.tenant_info?.org_id,
      }));

      setZohoPullTenantMapping(payload);
      setTenantData(copyData);
    } else {
      notification.error({
        message: `You need to have at least one mapping for sync ${documentUINames.salesOrderUIName}'s`,
        duration: 4,
        placement: 'top',
      });
    }
  };

  const tenantIdsToFilter = Array.isArray(tenantData) ? tenantData.map((zohoIds) => zohoIds?.zoho_branch_id) : [];

  const columns = [
    {
      title: 'Zoho Branch name',
      width: '275px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.zoho_branch_id}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'zoho_branch_id');
            }}
            placeholder="Select a location"
            dropdownAlign={{ offset: [-6, 4] }}
            style={{
              border: !(formSubmitted && !record?.zoho_branch_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              marginRight: '10px',
            }}
            disabled={connectTenantToLocationLoading}
          >
            {zohoConnections && zohoConnections?.filter((connection) => connection?.is_active)?.[0]?.branches
              ?.map((item) => (
                <Option
                  key={item.branch_id}
                  value={item.branch_id}
                  disabled={tenantIdsToFilter?.includes(item?.branch_id)}
                >
                  {`${item?.branch_name}`}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: 'Procuzy Tenant Name',
      width: '312px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record?.tenant_id}
            showSearch
            filterOption={false}
            onChange={(value) => {
              const orgId = tenants?.[0]?.org_id;
              updateTableValue(record?.key, value, 'tenant_id');
              updateTableValue(record?.key, orgId, 'org_id');
              setSearchKeyword('');
            }}
            placeholder="Select Business Unit"
            style={{
              border: !(formSubmitted && !record?.tenant_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              marginRight: '10px',
            }}
            onSearch={(value) => {
              setSearchKeyword(value);
            }}
            disabled={connectTenantToLocationLoading}
          >
            {tenants?.data
              ?.filter((item) => (searchKeyword ? item?.tenant_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))
              ?.map(
                (item) => <Option key={item?.tenant_id} value={item?.tenant_id}>{item?.tenant_name}</Option>,
              )}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: '',
      render: (record) => (
        <div>
          {!record?.zoho_facility_codes?.length ? (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              {' '}
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>

            </div>

          )}

        </div>
      ),

    },
  ];

  return (
    <Fragment>
      <div className="zoho__pull-tenant-mapping">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <Table
              columns={columns}
              loading={getTenantsLoading || getZohoConnectionsLoading || connectTenantToLocationLoading}
              dataSource={getDataSource(tenantData) || []}
              size="small"
              pagination={false}
              title={() => (
                <div style={{ display: 'flex', justifyContent: 'space-between', 'align-items': 'baseline' }}>
                  Please Select Mapping between
                </div>
              )}
              bordered={false}
            />
          </div>
        </div>
        <div className="new-row-button" style={{ marginLeft: '10px' }} onClick={() => addNewRow()}>
          <span className="new-row-button__icon"><PlusCircleFilled /></span>
          <div>New Item</div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, ZohoIntegrationReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  zohoConnections: ZohoIntegrationReducers.zohoConnections,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getZohoConnections: (orgId, callback) => dispatch(ZohoIntegrationActions.getZohoConnections(orgId, callback)),
});

ZohoPullTenantMapping.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getZohoConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  getZohoConnections: PropTypes.func,
  connectTenantToLocationLoading: PropTypes.bool,
  zohoConnections: PropTypes.any,
  pullVendorsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ZohoPullTenantMapping));
